import { render, staticRenderFns } from "./GlobalComponent.vue?vue&type=template&id=19f0a096&scoped=true"
import script from "./GlobalComponent.vue?vue&type=script&lang=ts"
export * from "./GlobalComponent.vue?vue&type=script&lang=ts"
import style0 from "./GlobalComponent.vue?vue&type=style&index=0&id=19f0a096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f0a096",
  null
  
)

export default component.exports